export const FeatureFlags = Object.freeze({
  NewProfileSettings: 'ff_new_profile_settings',
  UsioPaymentEnabled: 'ff_usio_payment_enabled',
  RemoveShareAccountButtonForAllExceptChicago:
    'ff_remove_share_account_button_for_all_except_chicago',
  QualtricsSurveys: 'ff_qualtrics_surveys',
})

export const VirtualIncentivePaymentFeatureFlags = Object.freeze({
  'VI physical reloadable card': 'ff_payout_vi_physical_reloadable_card',
  'VI virtual reloadable card': 'ff_payout_vi_virtual_reloadable_card',
  'VI paypal': 'ff_payout_vi_paypal',
  'VI venmo': 'ff_payout_vi_venmo',
  'VI ACH': 'ff_payout_vi_ach',
})
export const PaymentFeatureFlags = Object.freeze({
  PayPal: 'ff_payout_paypal',
  Venmo: 'ff_payout_venmo',
  ...VirtualIncentivePaymentFeatureFlags,
})
